<template>
  <section class="rule">
    <img src="https://cdn.gelonghui.com/webActive/img_explain_titlea.png" alt>
    <img src="https://cdn.gelonghui.com/webActive/img_explain_formc.png" alt>
    <img src="https://cdn.gelonghui.com/webActive/img_explain_contentb.png" alt>
    <img src="https://cdn.gelonghui.com/webActive/img_explain_systemb.png" alt>
    <img src="https://cdn.gelonghui.com/webActive/img_explain_serviceb.png" alt>
    <img src="https://cdn.gelonghui.com/webActive/img_explain_doubta.png" alt>
    <p>以上信息的最终解释权归格隆汇所有</p>
    <div v-if="deviceInfo.isInApp" class="buttons">
      <button class="gojoin" @click="goJoin">立即加入</button>
      <button class="goshare" @click="goshare">
        <img src="https://cdn.gelonghui.com/webActive/img_button_share.png" alt>
      </button>
    </div>
  </section>
</template>

<script>
  // import axios from "axios"
  export default {
    name: "rule",
    data() {
      return {
        val: "",
        deviceInfo: {
          userAgent: "",
          isInApp: false,
          isLogin: false,
          buyYear: true,
          iosVN: "",
          androidVN: ""
        },
        platForm: null
      };
    },
    created() {
      this.checkDeviceInfo();
      this.getPlatForm()
    },
    mounted() {
      window.checkIOSVN = null;
      window.checkIOSVN = result => {
        this.deviceInfo.iosVN = result;
      };
      document.title = "格隆汇会员体系介绍";
    },
    methods: {
      goJoin() {
        if (!this.deviceInfo.isLogin) {
          //判断是否登录
          this.goLogin();
          return;
        } else {
          let appVersion = this.platForm === 'ios' ? this.deviceInfo.iosVN : this.deviceInfo.androidVN //3.21.2
          let appIsUse = this.upToDate('5.9.9', appVersion)
          if (appIsUse) {
            this.$router.push({
              path: '/defaults'
            })
          } else {
            window.location.href =
              "https://www.gelonghui.com/user/member";
          }
        }
      },
      goLogin() {
        //-------------------------------登录
        switch (this.deviceInfo.userAgent) {
          case "iOS":
            // window.webkit.messageHandlers.iosPresentLoginPage.postMessage("");
            window.webkit.messageHandlers.iosPresentLoginWithFetchGuestPage.postMessage(
              ""
            );
            break;
          case "android":
            let timeInterval = setInterval(() => {
              let loginStatus = window.NativeInterface.isLogined();
              if (loginStatus) {
                this.deviceInfo.isLogin = true;
                window.clearInterval(timeInterval);
              }
            }, 1000);
            window.NativeInterface.doLogin();
            break;
        }
      },
      goshare() {
        //---------------------分享
        // console.log("我点了分享");
        let title = "加入格隆汇会员，发现价值，快人一步";
        let summary = "格隆汇会员体系介绍";
        let url = window.location.origin + window.location.pathname + "#/join";
        let image = "https://cdn.gelonghui.com/webActive/wechat-system.png";
        let shareType = "article";
        // console.log({
        //   title: title,
        //   content: summary,
        //   url: url,
        //   image: image
        // })
        if (this.deviceInfo.isInApp) {
          if (this.deviceInfo.userAgent === "iOS") {
            let pass_data = {
              title: title,
              content: summary,
              url: url,
              image: image
            };
            pass_data = JSON.stringify(pass_data);
            try {
              window.webkit.messageHandlers.iosPresentSharePage.postMessage(
                pass_data
              );
            } catch (err) {
              console.log(err);
            }
          } else {
            try {
              window.NativeInterface.share(title, summary, url, image, shareType);
            } catch (e) {
              console.log(e);
            }
          }
        } else {
          window.location.href =
            "https://www.gelonghui.com/app/device_redirect.html";
        }
      },
      checkDeviceInfo() {
        //----------------------------判断设备
        if (
          (window.NativeInterface && window.NativeInterface.isLogined) ||
          (window.webkit &&
            window.webkit.messageHandlers &&
            window.webkit.messageHandlers.iosCheckIsLoggedIn)
        ) {
          this.deviceInfo.isInApp = true;
        } else {
          this.deviceInfo.isInApp = false;
        }
        let ua = navigator.userAgent.toLowerCase();
        //判断设备
        if (this.deviceInfo.isInApp) {
          if (/iphone|ipad|ipod/.test(ua)) {
            // 在ios里
            this.deviceInfo.userAgent = "iOS";
            // this.getIntroduction();
            let loginOut = false;
            window.checkIOSVN = result => {
              this.deviceInfo.iosVN = result;
            };
            window.iosIsLogin = result => {
              loginOut = result;
              this.deviceInfo.isLogin = result;
              this.isLogin = result;
            };
            window.webkit.messageHandlers.iosFetchAppVersion.postMessage(
              "checkIOSVN"
            );
            window.webkit.messageHandlers.iosCheckIsAnyWayLogin.postMessage(
              "iosIsLogin"
            );
          } else if (/android/.test(ua)) {
            this.deviceInfo.userAgent = "android";
            let loginStatus = window.NativeInterface.isLogined();
            if (loginStatus) {
              this.deviceInfo.isLogin = true;
            }
          }
        } else {
          // window.location.href =
          //   "https://www.gelonghui.com/app/device_redirect.html";
        }
      },
      upToDate(local, remote) {
        var VPAT = /^\d+(\.\d+){0,2}$/;
        if (!local || !remote || local.length === 0 || remote.length === 0)
          return false;
        if (local == remote)
          return true;
        if (VPAT.test(local) && VPAT.test(remote)) {
          var lparts = local.split('.');
          while (lparts.length < 3)
            lparts.push("0");
          var rparts = remote.split('.');
          while (rparts.length < 3)
            rparts.push("0");
          for (var i = 0; i < 3; i++) {
            var l = parseInt(lparts[i], 10);
            var r = parseInt(rparts[i], 10);
            if (l === r)
              continue;
            return l > r;
          }
          return true;
        } else {
          return local >= remote;
        }
      },
      getPlatForm() {
        var ua = navigator.userAgent.toLowerCase();
        //判断设备
        if (/iphone|ipad|ipod/.test(ua)) {
          this.platForm = 'ios'
          window.webkit.messageHandlers.iosFetchAppVersion.postMessage(
            "checkIOSVN"
          );
        } else if (/android/.test(ua)) {
          this.platForm = 'android';
          this.deviceInfo.androidVN = window.NativeInterface.getVersionName()
        } else {
          this.platForm = 'web'
        }
      }
    }
  };

</script>
<style lang="less" scoped>
  * {
    margin: 0;
    padding: 0;
    list-style: none;
    text-decoration: none;
    box-sizing: border-box;
  }

  .rule {
    position: relative;
    padding-bottom: 100px;
    max-width: 750px;
    width: 100%;
    margin: 0 auto;
    text-align: center;
    // background-color: #282C37;
    background: #282c37 url(https://cdn.gelonghui.com/webActive/img_bg.png) no-repeat;
    background-size: 100%;

    img {
      width: 100%;
    }

    >p {
      margin-top: 40px;
      font-size: 20px;
      font-weight: 300;
      color: rgba(255, 255, 255, 0.2);
    }

    .buttons {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 88px;
      display: flex;

      >button {
        border: none;
        outline: none;
        text-align: center;
        font-size: 30px;
        font-weight: 600;
        color: rgba(120, 72, 47, 1);
        line-height: 88px;
      }

      .gojoin {
        width: 560px;
        height: 88px;
        background: rgba(255, 224, 170, 1);
      }

      .goshare {
        width: 190px;
        height: 88px;
        background: rgba(227, 187, 118, 1);

        img {
          width: 40px;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/member-share/rule.vue